// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 840 ? "f2d0f643" : chunkId) + "." + {"114":"4e7a4b9455189860","142":"849f540645dd0080","341":"1ea7a7ab32437817","471":"d2816db62aab40d7","781":"7fa05e1ca12003fa","840":"d06c17be8c39e66d"}[chunkId] + ".js";
};